import maButtonsNextActions from '@/components/button-blue'
import { mapState, mapActions } from 'vuex'
import downloadBlobFile from '@/utils/downloadBlobFile'
import { apiGetPdfMaterial } from '@/modules/Claim/services/pdf'
import {
  FLOW_MODULE_NAME,
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'

export default {
  name: 'damageValidation',

  mixins: [flowMixin],

  components: {
    maButtonsNextActions
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyResultDeclaration: 'resultDeclaration'
    }),
    paragraphs: function () {
      return this.getFlowViewContent.filter((c) => c.type === 'PARAGRAPH') || []
    },
    title: function () {
      const titleContent = this.getFlowViewContent.find(
        (c) => c.type === 'TITLE'
      )
      return titleContent ? titleContent.literal : ''
    },
    text1: function () {
      return this.paragraphs[0] ? this.paragraphs[0].literal : ''
    },
    text2: function () {
      return this.paragraphs[1] ? this.paragraphs[1].literal : ''
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    handlePrimaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.FINISHED_OK)
    },

    handleSecondaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.FINISHED_KO)
    },

    handleTertiaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.SHOW_COMPENSATION_TYPE)
    },

    /**
     * This method handles the API call related to generate a pdf materials
     * list report.
     */
    handleClickMaterialList() {
      apiGetPdfMaterial(this.getSinisterId).then((data) => {
        downloadBlobFile(data, 'Material_summary.pdf')
      })
    }
  },

  /**
   * Updates warranty and user state with url params
   */
  mounted() {
    const sinisterId = this.getSinisterId
    this.actGetResultDeclaration(sinisterId)
  }
}
